import { ISignificantSalesChangesParams, ISummaryChartParams } from "api/types";

export const environments = {
  PRODUCTION: "production",
  DEVELOPMENT: "development",
};

export const MUI_KEY = process.env.REACT_APP_MUI_KEY;
export const REACT_APP_COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;
export const REACT_APP_COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION;
export const REACT_APP_COGNITO_CLIENT_ID =
  process.env.REACT_APP_COGNITO_CLIENT_ID;
export const REACT_APP_COGNITO_CALLBACK_URL =
  process.env.REACT_APP_COGNITO_CALLBACK_URL;
export const REACT_APP_PROD_API = process.env.REACT_APP_PROD_API;
export const REACT_APP_API_LOGIN = process.env.REACT_APP_API_LOGIN;
export const REACT_APP_PROD_API_RIDGEWOOD = process.env.REACT_APP_PROD_API;
export const REACT_APP_DEV_RESTOCK = process.env.REACT_APP_PROD_API_RIDGEWOOD;
export const REACT_APP_SUBSCRIPTION = process.env.REACT_APP_SUBSCRIPTION;
export const REACT_APP_MASTER_ADMIN = process.env.REACT_APP_MASTER_ADMIN;
export const API_SERVER_PATH = process.env.API_SERVER_PATH;
export const DEMO_API =
  "https://w174o7g6m1.execute-api.us-east-1.amazonaws.com/demo/";
export const DEMO_NODE_API =
  "https://c1j00vvac8.execute-api.us-east-1.amazonaws.com/demo/";
export const CURRENT_ENVIRONMENT = process.env.REACT_APP_CURRENT_ENV;

export const COGNITO_LOGIN_URL = `https://${REACT_APP_COGNITO_DOMAIN}.auth.${REACT_APP_COGNITO_REGION}.amazoncognito.com/login?client_id=${REACT_APP_COGNITO_CLIENT_ID}&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=${REACT_APP_COGNITO_CALLBACK_URL}`;

export const DRAWER_WIDTH = 260;

export const ridgeWoodId = "ca5bc57f-62b4-4cd2-8508-78fb302e190a";

export const PATHS = Object.freeze({
  GET_REPLENISHMENT_DATA: "api/v1/inventory/restock-summary",
  GET_REPLENISHMENT_DATA_DEV: "api/replenishment",
  GET_USER_DETAILS: "users/me",
  GET_COMPANY_ANALYTICS: "/api/analytics/company",
  GET_USER_ANALYTICS: "/api/analytics/sellers",
  SAVE_REPLENISHMENT_DATA: "api/v1/inventory/manual-override",
  GET_SELLER_LIMITS_DATA: "api/v1/inventory/summary-view",
  GET_REPLENISHMENT_CALCULATION_STATUS:
    "api/v1/inventory/restock-calculation-history",
  LOGIN: "api/login/",
  SIGNUP: "api/signup/",
  SIGNUP_INIT: "api/signup/init/",
  SIGNUP_CONFIRM: "api/confirm/signup",
  RESEND_OTP: "api/code/resend/",
  REPLENISHMENT_DOWNLOAD: "api/replenishment/download",
  GET_SHIPMENT_DATA_DEV: "api/v1/shipments",
  REPLENISHMENT_UPLOAD: "api/replenishment/upload",
  REPLENISHMENT_CHART: "api/replenishment/chart",
  SALES_REPORTS: "reports",
  DOWNLOAD_REPORT: (report_id: string) => `reports/${report_id}/file`,
  SHIPMENT_ACTION: (shipmentId: string, state: any) =>
    `api/v1/shipments/${shipmentId}/dispute?State=${state}`,
  CREATE_APOLLO_SHIPMENT_DISPUTE: (shipmentId: string) =>
    `api/v1/shipments/${shipmentId}/dispute`,
  GET_FORCASTING_DATA_DEV: "api/forecasting",
  FORCASTING_MANNUAL_OVERRIDE: "api/forecast/manual-override",
  FORCASTING_CHART: (seller_ids: string[], top_asins: number = 20) =>
    `api/forecasting/chart?seller_ids=${seller_ids}&top_asins=${top_asins}`,
  SHIPMENT_CHART: (no_of_weeks: number, seller_ids: string[]) =>
    `api/shipment/chart/?no_of_weeks=${no_of_weeks}&seller_ids=${seller_ids}`,
  SELLERS_LIST: (no_of_weeks: number, seller_ids: string[]) =>
    `api/shipment/download/?no_of_weeks=${no_of_weeks}&seller_ids=${seller_ids}`,
  LISTING_HEALTH: "api/listing-health/",
  LISTING_HEALTH_CHART: `api/listing-health/chart`,
  LISTING_HEALTH_DOWNLOAD: "api/listing-health/download",
  SAVE_SHIPMENT_CASE_ID: (shipmentId: string) =>
    `api/v1/shipments/${shipmentId}/dashboard-details`,
  FORCASTING_UPLOAD: "api/forecasting/upload",
  DOWNLOAD_KEPLER_SHIPMENT_CREATION_TEXT: (filetype: string = "text") =>
    `api/v1/shipments/file?fileType=${filetype}`,
  FORECASTING_ASIN_OR_SELLER: (status: boolean) =>
    `api/v1/forecast/manual-override?defaults=${status}`,
  PUT_FORECASTING_DATA: `api/forecast/manual-override/`,
  MISMATCH_SUMMARY: "api/catalog-tracker/mismatch-summary",
  MISMATCH_SUMMARY_DOWNLOAD: "api/catalog-tracker/download/catalog-template",
  MISMATCH_SUMMARY_UPLOAD: "api/catalog-tracker/upload/",
  CATALOG_ATTRIBUTES: (asin: string, seller_id: string) =>
    `api/catalog-tracker?asin=${asin}&seller_id=${seller_id}`,
  FORCASTING_ASIN_OR_SELLER: (status: boolean) =>
    `api/v1/forecast/manual-override?defaults=${status}`,
  SALES_CHANGES_DATA: "api/v1/sales/changes",
  SALES_CHANGES_TABLE: "api/v1/sales/changes",
  SIGNIFICANT_SALES_CHANGES_CHART:
    "api/performance-dashboard/sales-changes/chart",
  SIGNIFICANT_SALES_CHANGES_TABLE: "api/performance-dashboard/sales-changes",

  GET_PROMOTION_CALENDAR_DATA: (
    aggregationType: string,
    timeFrames: number,
    sellerId: string,
    asin?: string
  ) =>
    `api/promotions/calendar-view/?aggregation_type=${aggregationType}&time_frames=${timeFrames}&seller_id=${sellerId}`,
  GET_PROMOTION_CALENDAR_TABLE_DATA: "api/promotions/summary-view/",
  GET_RANGER_DATA: "api/fulfillment-fees/dimension-improvement/catalog",
  CALCULATE_RANGER_DATA: "api/fulfillment-fees/catalog/calculate",
  RANGER_UPLOAD: "api/fulfillment-fees/catalog/upload",
  CALCULATOR_TEMPLATE_DOWNLOAD:
    "api/fulfillment-fees/download/product-fba-information-template",

  SALES_CHANGES_INCREASE_CHART: `api/sales-changes/chart/increasing/`,
  SALES_CHANGES_DECREASE_CHART: `api/sales-changes/chart/decreasing/`,

  SALES_CHANGES_TABLE_DATA: `api/sales-changes`,
  SALES_DASHBOARD_DATA: (
    aggregation_type: string,
    time_frames: string,
    seller: string
  ) =>
    `api/performance-dashboard/sales-data?aggregation_type=${aggregation_type}&time_frames=${time_frames}&seller_id=${seller}`,
  SALES_BREAKOUT_DATA: `api/performance-dashboard/sales-breakout`,
  SHIPMENT_STATUS: (no_of_days: string, seller_id: string) =>
    `api/performance-dashboard/shipment-status?number_of_shipments=${no_of_days}&seller_id=${seller_id}`,
  INVENTORY_POSITION_DATA: (topAsins: string, seller_id: string) =>
    `api/performance-dashboard/inventory-position?top_asin_count=${topAsins}&seller_id=${seller_id}`,
  RANK_CHANGES_DATA: "api/performance-dashboard/search-rank/chart",
  RANK_CHANGES_ADD: "api/performance-dashboard/search-rank/chart",
  SUMMARY_CHART: ({
    time_frames,
    aggregation_type,
    seller_id,
  }: ISummaryChartParams) =>
    `api/performance-dashboard/item-summary?aggregation_type=${aggregation_type}&time_frames=${time_frames}&seller_id=${seller_id}`,

  ADVERTISING_DATA: (
    seller_id: string,
    aggregation_type: string,
    grouping_type: string,
    time_frames: number,
    top_x: string
  ) =>
    `api/performance-dashboard/advertising-callouts?seller_id=${seller_id}&aggregation_type=${aggregation_type}&grouping_type=${grouping_type}&time_frames=${time_frames}&top_x=${top_x}`,
  ADVERTISING_LIST: (
    seller_id: string,
    aggregation_type: string,
    grouping_type: string,
    time_frames: string
  ) =>
    `api/performance-dashboard/advertising-callouts/download/?seller_id=${seller_id}&aggregation_type=${aggregation_type}&grouping_type=${grouping_type}&time_frames=${time_frames}`,
  TOTAL_SALES_SNAPSHOT: `api/performance-dashboard/sales-data/snapshot`,
  FBA_MEASUREMENT: "api/fulfillment-fees/fba-measurement/catalog",
  FBA_MEASUREMENT_UPLOAD:
    "api/fulfillment-fees/fba-measurement/catalog/upload ",
  DIMENSION_IMPROVEMENT_UPLOAD: "api/fulfillment-fees/upload",
  SAVE_CONFIG: `api/user-configurations`,
  GET_CONFIG: `api/user-configurations`,
  ADD_SEARCH_TERM: `api/performance-dashboard/search-rank`,
  SEARCH_RANK: (seller_id: string) =>
    `api/performance-dashboard/search-rank?seller_id=${seller_id}`,
  AMAZON_PAYMENT: `api/payment-reports/amazon-payment-view`,
  AMAZON_PAYMENT_DOWNLOAD: `api/payment-reports/amazon-payment-view/download`,
  ACCOUNTING_TABLE: `api/payment-reports/accounting-payment-view`,
  ACCOUNTING_DOWNLOAD: `api/payment-reports/accounting-payment-view/download`,
  INVENTORY: `api/payment-reports/inventory-view`,
  INVENTORY_DOWNLOAD: `api/payment-reports/inventory-view/download`,
  PNL_VIEW: `api/payment-reports/pnl-item-view`,
  PNL_EDIT: (seller: string) =>
    `api/payment-reports/pnl-view/product-cost/snapshot/?seller_id=${seller}`,
  PNL_EDIT_SAVE: `api/payment-reports/pnl-view/product-cost/snapshot`,
  PNL_PAYMENT_VIEW: `api/payment-reports/pnl-payment-view`,
  PNL_PAYMENT_VIEW_CHART: `api/payment-reports/pnl-view/chart`,
  INVENTORY_VIEW_DOWNLOAD: `api/payment-reports/invnetory-view/download`,
  CREATE_SELLERS: `sellers`,
  CREATE_OR_GET_ALL_USERS: `api/user/`,
  GET_OR_MODIFY_COMPANY: (companyId: string) => `companies/${companyId}`,
  GET_SPECIFIC_USER: `api/user/`,
  GET_SELLER_STATUS: "api/sellers/onboarding/status",
  PNL_DOWNLOAD: `api/payment-reports/pnl-payment-view/download`,
  LOOKUP: `api/payment-lookup`,
  GET_DASHBOARD_DATA: "api/dashboard",
  LOOKUP_DOWNLOAD: `api/payment-lookup/download`,
  LOOKUP_UPLOAD: `api/payment-lookup/upload`,
  PNL_SUBMIT: `api/payment-reports/pnl-view/snapshot/`,
  CHANGE_PASSWORD: "api/reset",
  FORECASTING_DOWNLOAD: "api/forecasting/download",
  FORECASTING_EDIT_DATA_DOWNLOAD: "api/forecast/manual-override/download",
  SUBSCRIPTION_DETAILS: `customers/subscriptions`,
  PAYMENT_CHECKOUT: "checkout-session",
  PRODUCT_CHECKOUT: "checkout/product/",
  PAYMENT_STATUS: (session_id: string) =>
    `checkout-session?session_id=${session_id}`,
  CUSTOMER_PORTAL: "customers/billing-portal/",
  ACTIVE_OR_INACTIVE_SELLER: "api/sellers/change-status/",
  MODIFY_USER_ROLE: (userId: string) => `users/${userId}/role`,
  USER_HAS_SELLER_NOT: "api/sellers/active/",
  PNL_EDIT_DOWNLOAD: (seller: string) =>
    `api/payment-reports/pnl-view/product-cost/snapshot/download/?seller_id=${seller}`,
  PNL_EDIT_UPLOAD: `api/payment-reports/pnl-view/product-cost/snapshot/upload`,
  CURIOSITY_UPVOTE: "api/upvote/",
  CURIOSITY_FEEDBACK: "api/user-feedback/",
  VERIFY_USERNAME: "api/forgot-password/",
  FORGOT_PASSWORD: "api/confirm/forgot-password/",
  ADVERTISING_CHART: (
    seller_id: string,
    aggregation_type: string,
    grouping_type: string,
    time_frames: number,
    top_x: string
  ) =>
    `api/performance-dashboard/advertising-callouts/chart/?seller_id=${seller_id}&aggregation_type=${aggregation_type}&grouping_type=${grouping_type}&time_frames=${time_frames}&top_x=${top_x}`,
  RANGER_SNAPSHOT: "api/fulfillment-fees/fba-snapshot",
  AMAZON_FBA_FEES_RATED_TEMPLATE_DOWNLOAD:
    "api/fulfillment-fees/download/amazon-storage-fba-category-template",
  AMAZON_FBA_FEES_RATED_TEMPLATE_UPLOAD:
    "api/fulfillment-fees/amazon-fba-fee-chart",
  CALCULATE_DIMENSION_IMPROVEMENT:
    "api/fulfillment-fees/dimension-improvement/calculate/",
  DIMENSION_IMPROVEMENT_DOWNLOAD:
    "api/fulfillment-fees/dimension-improvement/catalog/download",
});

export const SUBSCRIPTION_STATUS = {
  TRAILING: "trailing",
  CANCEL: "cancel",
  ACTIVE: "active",
};

export const LOCAL_STORAGE_KEY_ACCESS_TOKEN = "access_token";

export const MUI_TABLE_STYLES = {
  fontFamily: "Lato",
  fontWeight: 400,
  borderRadius: "8px",
  BorderRight: "1px solid black",
  "& .left-align-field": {
    justifyContent: "flex-start !important",
    paddingLeft: "80px !important",
  },
  "& .right-align-field": {
    display: "flex",
    justifyContent: "flex-end !important",
    paddingRight: "80px !important",
  },
  "& .center-align-field": {
    justifyContent: "center !important",
    textAlign: "left !important",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
    borderRight: "1px solid lightgrey",
  },
  "& .MuiDataGrid-groupingCriteriaCell": {
    fontWeight: "bold !important",
  },

  "&  .MuiDataGrid-columnHeaderTitleContainerContent:hover": {
    // lineHeight: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  // "&  .MuiDataGrid-columnHeaderTitleContainerContent": {
  //   textOverflow: "ellipsis",
  //   overflow: "hidden",
  // },

  "& .MuiDataGrid-columnHeader--filledGroup": {
    background: "#BBDEFB",
    fontWeight: 600,
    BorderRight: "1px solid black",
  },
  "&  .MuiDataGrid-columnHeader--filledGroup:nth-of-type(even)": {
    background: "lightgrey",
  },

  "& .MuiDataGrid-columnHeader": {
    background: "#E3F2FD",
    fontWeight: 400,
  },

  "& .MuiDataGrid-columnHeaderTitleContainer": {
    justifyContent: "center",
    fontWeight: 400,
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    justifyContent: "center",
    BorderRight: "1px solid black",
    fontWeight: 600,
    color: "#424242",
  },
  "& .MuiDataGrid-footerContainer": {
    background: "rgba(220, 227, 235, 0.3)",
    justifyContent: "start",
  },

  "&  .MuiDataGrid-cell": {
    //   background: "lightgray !important",
  },
  "&  .MuiDataGrid-cell--editable": {
    background: "rgba(25, 118, 210, 0.12) !important",
  },
  "&  .MuiDataGrid-cell--editing": {
    background: "rgba(25, 118, 210, 0.12) !important",
  },
  "& .MuiTablePagination-selectLabel ": {
    color: "#424242",
    fontSize: "14px",
    fontWeight: "400",
    fontFamily: "Lato",
  },
  "& .MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root": {
    color: "rgba(1, 74, 124, 1)",
  },
  "& .MuiInputBase-root MuiInputBase-colorPrimary css-16c50h-MuiInputBase-root-MuiTablePagination-select":
    {
      borderRadius: "4px",
      margin: "10px 20px",
      border: "1px solid #9E9E9E",
    },
  "& .MuiPaginationItem-root .Mui-selected": {
    background: "linear-gradient(90deg, #034D80 0%, #2C97E0 100%);",
  },
  "& .MuiDataGrid-cell MuiDataGrid-cell--textRight": {
    background: "lightgray !important",
  },

  "& .MuiDatMuiDataGrid-columnHeader .MuiDataGrid-withBorderColor": {
    background: "#E3F2FD !important",
  },
};

export const TABLE_PAGINATION_STYLES = {
  "& .MuiInputBase-root .MuiInputBase-colorPrimary .MuiTablePagination-select":
    {
      border: "1px solid #9E9E9E",
      borderRadius: "4px",
    },
  "& .MuiSvgIcon-root": {
    color: "#034D80",
  },
  "& .MuiTablePagination-spacer": {
    display: "none",
  },
};

export const TABLE_DISABLED_STYLES = {
  "& .MuiDataGrid-columnHeader--filledGroup": {
    background: "lightgrey",
    fontWeight: 600,
    BorderRight: "1px solid black",
  },
  "&  .MuiDataGrid-columnHeader--filledGroup:nth-of-type(even)": {
    background: "lightgrey",
  },

  "& .MuiDataGrid-columnHeader": {
    background: "lightgrey",
    fontWeight: 400,
  },
  "&  .MuiDataGrid-cell--editable": {
    background: "lightgrey !important",
  },
};

export const WIDGETS = {
  TOTAL_SALES_SUMMARY: "total-sales-summary",
  SALES_BREAKOUT: "sales-breakout",
  ITEM_CALLOUT: "item-callout",
  INVENTORY_POSITION: "inventory-position",
  SHIPMENT_STATUS: "shipment-status",
  ADVERTISING: "advertising",
  SUMMARY_CHART: "summary-chart",
  RANK_CHANGES: "rank-changes",
};

export const COLORS = {
  red: "#f14c4c",
  yellow: "#ffa500",
  orange: "#f78b4f",
  blue: "linear-gradient(0deg, #004779 0%, #0275C4 100%);",
};

export const DASHBOARD_DEMO_DATA_TOKEN =
  "eyJraWQiOiJUM1FnQ3pBSTVxR1UxN21GN1B0bEJpRWlZbVBVaFJVcTNYenkzcDNYT1JrPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI4ZTUyYzI1OC0zNGIxLTQ1ZjMtOTM4OS1jY2Y1YWM1ZmZjMmMiLCJjb2duaXRvOmdyb3VwcyI6WyI2ZGY4N2E2Ny0wODE4LTRjNjEtOGY3Zi03MWViYWMyYzBkNzYiLCJERUZBVUxUX0NVU1RPTUVSUyIsIkNvbXBhbnlBZG1pbiJdLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0xLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMV9hRVhuUlQzWjEiLCJjbGllbnRfaWQiOiIzYm1sNnFhbDd0NmtuNnFmdjY0aDc3cnBqZiIsIm9yaWdpbl9qdGkiOiJmZjczM2NlMi05ZWY5LTRhZTUtODJkZi00NDYzNzFjOWIzNWYiLCJldmVudF9pZCI6IjQ4YThiZDNkLTFlYmUtNGRiMS04Mzk0LWQ5ZTFhMTRiYTNkMiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2Nzk5MTg1MTcsImV4cCI6MTY3OTkyMjExNywiaWF0IjoxNjc5OTE4NTE3LCJqdGkiOiI4MzUyMDgzNy0xNDAyLTQ2MzctYThiZS0zM2Q4Njg5ZGY2YjYiLCJ1c2VybmFtZSI6IjhlNTJjMjU4LTM0YjEtNDVmMy05Mzg5LWNjZjVhYzVmZmMyYyJ9.Wuy0Xca8q74qOPeuCPYJgV247te3tvpHR4HAPGFVCgfyEUayPoy_B0H7nUg7bOa0tXfa1I4xa3rkVUpfKG9SXgX95K9iOO-r1yC-ijGbU8d-0vJrFfOg6pr64i_imvtQ89axoxv0_8lk78uhBBuoCF92C373hasl99jG1qhBoDCwKLd0-G9d1nfiCxeomBi6DjAqV0x1l__nd_t-6wppGvWgz1pJGMZbCZkQbOj_o92gi6WXr4dAD7iOuRhHtzAqr6p3EgqGQvGmcmHLlLN9OfSKbyo2nSSmSVNQvCx7dVaZPT6DHoMYjI-upv3VnDSzEBXD6IdVxIRg2_yGDwxdug";

export const INITIAL_COLORS = {
  1: COLORS.blue,
  2: COLORS.blue,
  3: COLORS.blue,
  4: COLORS.blue,
  5: COLORS.blue,
  6: COLORS.blue,
};

export const PNLViewTableStyle = {
  fontWeight: "bold",
  fontSize: "small",
  whiteSpace: "break-spaces",
  textOverflow: "clip",
  lineHeight: 1,
  paddingTop: "0.15rem",
};

export const MOBILE_SCREEN_WIDTH = "(max-width: 768px)";

export const DATE_FORMAT = "MM_DD_YYYY";
